import Instrument from "shared/games/instruments/Instrument";
import { MixPuzzleInstrument } from "shared/games/mixpuzzles/types";
import prettyInstrument from "util/formatters/prettyInstrument";
import FixedWhenScrolledMobileBar from "../atoms/FixedWhenScrolledMobileBar";

interface Props {
  instrument: MixPuzzleInstrument;
}

export default function PatchedInFixedStatusBar({
  instrument: { instrument },
}: Props) {
  return (
    <FixedWhenScrolledMobileBar>
      Patched in:{" "}
      <span className={"text-purple-400"}>{prettyInstrument(instrument)}</span>
    </FixedWhenScrolledMobileBar>
  );
}
